import React, { FC } from 'react';

import Collection from '../../../../components/./Collection/Collection';
import Container from '../../../../components/Container';
import { PostalCodeResource } from '../../../../models';
import StreetTable from '../../../../models/streets/StreetTable';
import { Size } from '../../../../theme/types';

const PostalCodeStreetsTab: FC<{ postalCode: PostalCodeResource }> = ({ postalCode }) => {
  return (
    <Container size={Size.Large}>
      <Collection opts={{ filter: { postalDigits: [postalCode.id] } }} resourceType="streets">
        <StreetTable />
      </Collection>
    </Container>
  );
};

export default PostalCodeStreetsTab;
